import { render, staticRenderFns } from "./LogoutAlertDialog.vue?vue&type=template&id=25f1e5dd"
import script from "./LogoutAlertDialog.vue?vue&type=script&lang=js"
export * from "./LogoutAlertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports